module.exports = __webpack_public_path__ + "img/Icon_Mapa.069ac8d2.png";